import { CheckOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";
import React from "react";

const SuccessModal = ({
  visible,
  onClose,
  isCreateButton,
  successMessage,
  contractRef,
}) => {
  const { Title, Paragraph } = Typography;

  return (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      centered
      width={420}
      style={{ borderRadius: "12px", padding: "10px" }}
    >
      <div style={{ padding: "24px 0" }}>
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "left",
            flexDirection: "column",
          }}
        >
          {/* <CheckCircleFilled style={{ fontSize: "24px", color: "#079455",backgroundColor:"#DCFAE6" }} /> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#e6f7e9",
              // marginBottom: "10px",
            }}
          >
            <CheckOutlined style={{ fontSize: "24px", color: "#079455" }} />
          </div>
          <Title level={3} style={{}}>
            Successful
          </Title>
        </div>
        <Paragraph
          style={{
            fontSize: "14px",
            color: "#666",
            // marginBottom: "24px",
            marginTop: 0,
          }}
        >
          {successMessage}
          {isCreateButton && (
            <h2 style={{ fontSize: "16px" }}>Contract ID: {contractRef}</h2>
          )}
        </Paragraph>
        {/* Add a container div with flex properties to align the button to the right */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="primary"
            style={{
              width: "100%",
              backgroundColor: "#BA24D5",
              color: "white",
              height: "44px",
            }}
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
